// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__tSr2x","title":"FrontImage_title__1mshv"};